import React, { createElement } from 'react';
import Style from './index.module.scss';
import withHover from '@ifeng/lowcode_tool/src/hoc/withHover'

export interface AtomLinkProps {
    nodeId?: string
    style: object;
    children: string;
    link?: string;
    isTargetBlank: boolean;
    __designMode: string
}

const AtomLink: React.FC<AtomLinkProps> = (props) => {
    const { nodeId, style, children, link, isTargetBlank, __designMode } = props;

    return (
        <a
            id={nodeId}
            className={Style.wrap}
            {...(__designMode !== 'design' ? { href : link} : {})}
            {...(isTargetBlank ? { target: '_blank' } : {})}
            style={{ ...style }}
        >
            {children}
        </a>
    );
};

export default withHover(AtomLink);
